import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setAppTitle } from '../../../store/commonSlice'

import {
  chart,
  truck1,
  truck2,
  truck3,
  truck4,
  truck5,
  truck6,
  truck7,
} from '../../../utils/images/imagepath'

function AdminDashboard() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setAppTitle('Dashboard'))
  }, [])

  return (
    // <div classNameName='page-header'>
    //   <div classNameName='row'>
    //     <div classNameName='col-sm-12'>
    //       <h3 classNameName='page-title'>Welcome Admin!</h3>
    //       <ul classNameName='breadcrumb'>
    //         <li classNameName='breadcrumb-item active'>Dashboard</li>
    //       </ul>
    //     </div>
    //   </div>
    // </div>
    // <!-- Page Wrapper -->
    <>
      {/* <!-- Page Header --> */}
      <div className='page-header'>
        <div className='row align-items-center'>
          <div className='col-sm-6'>
            <h3 className='page-title'>Dashboard</h3>
          </div>
          <div className='col-sm-6'>
            <ul className='breadcrumb'>
              <li className='breadcrumb-item active'>
                <a href='index.html'>Home</a>
              </li>
              <li className='breadcrumb-item'>Dashboard</li>
            </ul>
          </div>
        </div>
      </div>
      {/* <!-- /Page Header --> */}

      {/* <!-- Dashboard --> */}
      <div className='dashboard-info'>
        <div className='row'>
          <div className='col-xl-6 col-lg-12'>
            <div className='dashboard-card'>
              <ul className='nav'>
                <li>
                  <div className='dashboard-inner'>
                    <div className='dashboard-inner-text'>
                      <h6>Total Trucks</h6>
                      <h4>
                        150+
                        <span className='dash-trucks-count'>
                          10 <i className='ti ti-arrow-up-right'></i>
                        </span>
                      </h4>
                      <p>Last Month: 10+ Newly Added</p>
                    </div>
                    <div className='dashboard-inner-icon'>
                      <span>
                        <i className='icon-trucks-list'></i>
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className='dashboard-inner'>
                    <div className='dashboard-inner-text'>
                      <h6>Completed Checklist</h6>
                      <h4>
                        15+
                        <span className='dash-checklist'>
                          2 <i className='ti ti-arrow-up-right'></i>
                        </span>
                      </h4>
                      <p>Last Month: 25+ Checklist Completed</p>
                    </div>
                    <div className='dashboard-inner-icon'>
                      <span>
                        <i className='icon-checklist'></i>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
              <ul className='nav dashboard-inner-nav'>
                <li>
                  <div className='dashboard-inner'>
                    <div className='dashboard-inner-text'>
                      <h6>Blocker</h6>
                      <h4>
                        15+
                        <span className='dash-blocker'>
                          -2 <i className='ti ti-arrow-down-right'></i>
                        </span>
                      </h4>
                      <p>Last Month: 5 Blocker Trucks </p>
                    </div>
                    <div className='dashboard-inner-icon'>
                      <span>
                        <i className='icon-checklist'></i>
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className='dashboard-inner'>
                    <div className='dashboard-inner-text'>
                      <h6>Total Drivers</h6>
                      <h4>
                        150+
                        <span className='dash-trucks-count'>
                          10 <i className='ti ti-arrow-up-right'></i>
                        </span>
                      </h4>
                      <p>Last Month: 2+ New Drivers Added</p>
                    </div>
                    <div className='dashboard-inner-icon'>
                      <span>
                        <i className='icon-profile'></i>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className='col-xl-6 col-lg-12 d-flex'>
            <div className='card dash-card w-100'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-xl-8 col-lg-12'>
                    <div className='card-header'>
                      <h4 className='card-title'>Newly Added</h4>
                      <a href='javascript:void(0);' className='view-all-link'>
                        View All
                      </a>
                    </div>
                    <ul className='nav'>
                      <li>
                        <p>Vehicle Number</p>
                        <h6>452BG2654</h6>
                      </li>
                      <li>
                        <p>Driver Name</p>
                        <h6>Joseph Arimathea</h6>
                      </li>
                      <li>
                        <p>Overall Checklist</p>
                        <h6>Completed</h6>
                      </li>
                      <li>
                        <p>Driver Name</p>
                        <span className='active-name'>Active</span>
                      </li>
                    </ul>
                  </div>
                  <div className='col-xl-4 col-lg-12'>
                    <div className='dash-truck-img'>
                      <img src={truck1} className='img-fluid' alt='Truck' />
                    </div>
                  </div>
                </div>
                <div className='card-footer'>
                  <a href='javascript:void(0);' className='btn btn-light'>
                    View Details
                  </a>
                  <a href='javascript:void(0);' className='btn btn-primary'>
                    Go to Checklist
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-xl-8 col-lg-12'>
            <div className='dashboard-header'>
              <div className='row align-items-center'>
                <div className='col-md-6'>
                  <h4>Trucks & Drivers List</h4>
                </div>
                <div className='col-md-6'>
                  <div className='dashboard-nav-list'>
                    <ul className='nav'>
                      <li>
                        <a href='javascript:void(0);' className='active'>
                          All
                        </a>
                      </li>
                      <li>
                        <a href='javascript:void(0);'>Active</a>
                      </li>
                      <li>
                        <a href='javascript:void(0);'>Minor</a>
                      </li>
                      <li>
                        <a href='javascript:void(0);'>Blocker</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className='card table-card'>
              <div className='card-body'>
                <div className='row align-items-center'>
                  <div className='col-md-6'>
                    <div id='tablelength'></div>
                  </div>
                  <div className='col-md-6'>
                    <ul className='nav nav-table-filter'>
                      <li>Search:</li>
                      <li>
                        <div id='tablefilter'></div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='table-responsive'>
                  <table className='table datatable mb-0'>
                    <thead>
                      <tr>
                        <th className='no-sort'>
                          <div className='table-checkbox'>
                            <label className='check-input'>
                              <input type='checkbox' />
                              <span className='box'></span>
                            </label>
                          </div>
                        </th>
                        <th>Truck Details</th>
                        <th>Driver Details</th>
                        <th>Checklist</th>
                        <th>Status</th>
                        <th className='no-sort'></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className='table-checkbox'>
                            <label className='check-input'>
                              <input type='checkbox' />
                              <span className='box'></span>
                            </label>
                          </div>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck1}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Garbage Truck <span>AB06 CD 1234</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck2}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Cameron Jacob <span>ABC Company</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <div className='data-check-list'>
                            <ul className='nav'>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                            </ul>
                            <p>
                              28/<span>30</span>
                              <a
                                href='javascript:void(0);'
                                className='view-checklist'
                              >
                                View Checklist
                              </a>
                            </p>
                          </div>
                        </td>
                        <td>
                          <span className='badge bg-light-success'>Active</span>
                        </td>
                        <td className='table-action'>
                          <div className='dropdown'>
                            <a
                              href='javascript:void(0);'
                              className='dropdown-toggle'
                              data-bs-toggle='dropdown'
                            >
                              <i className='feather-more-vertical'></i>
                            </a>
                            <div className='dropdown-menu dropdown-menu-end'>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-eye'></i> View
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-edit'></i> Edit
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-trash-2'></i> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className='table-checkbox'>
                            <label className='check-input'>
                              <input type='checkbox' />
                              <span className='box'></span>
                            </label>
                          </div>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck3}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Semi- Truck <span>AB06 CD 1234</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck4}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Nicholas <span>ABC Company</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <div className='data-check-list'>
                            <ul className='nav'>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-danger'></span>
                              </li>
                              <li>
                                <span className='check-list-danger'></span>
                              </li>
                              <li>
                                <span className='check-list-danger'></span>
                              </li>
                            </ul>
                            <p>
                              15/<span>30</span>
                              <a
                                href='javascript:void(0);'
                                className='view-checklist'
                              >
                                View Checklist
                              </a>
                            </p>
                          </div>
                        </td>
                        <td>
                          <span className='badge bg-light-danger'>
                            Blacklist
                          </span>
                        </td>
                        <td className='table-action'>
                          <div className='dropdown'>
                            <a
                              href='javascript:void(0);'
                              className='dropdown-toggle'
                              data-bs-toggle='dropdown'
                            >
                              <i className='feather-more-vertical'></i>
                            </a>
                            <div className='dropdown-menu dropdown-menu-end'>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-eye'></i> View
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-edit'></i> Edit
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-trash-2'></i> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className='table-checkbox'>
                            <label className='check-input'>
                              <input type='checkbox' />
                              <span className='box'></span>
                            </label>
                          </div>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck5}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Tow Truck <span>AB06 CD 1234</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck6}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Edmunds Gray <span>ABC Company</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <div className='data-check-list'>
                            <ul className='nav'>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-warning'></span>
                              </li>
                              <li>
                                <span className='check-list-warning'></span>
                              </li>
                              <li>
                                <span className='check-list-warning'></span>
                              </li>
                            </ul>
                            <p>
                              19/<span>30</span>
                              <a
                                href='javascript:void(0);'
                                className='view-checklist'
                              >
                                View Checklist
                              </a>
                            </p>
                          </div>
                        </td>
                        <td>
                          <span className='badge bg-light-warning'>Minor</span>
                        </td>
                        <td className='table-action'>
                          <div className='dropdown'>
                            <a
                              href='javascript:void(0);'
                              className='dropdown-toggle'
                              data-bs-toggle='dropdown'
                            >
                              <i className='feather-more-vertical'></i>
                            </a>
                            <div className='dropdown-menu dropdown-menu-end'>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-eye'></i> View
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-edit'></i> Edit
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-trash-2'></i> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className='table-checkbox'>
                            <label className='check-input'>
                              <input type='checkbox' />
                              <span className='box'></span>
                            </label>
                          </div>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck6}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Garbage Truck <span>AB06 CD 1234</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck7}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Cameron Jacob <span>ABC Company</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <div className='data-check-list'>
                            <ul className='nav'>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                            </ul>
                            <p>
                              28/<span>30</span>
                              <a
                                href='javascript:void(0);'
                                className='view-checklist'
                              >
                                View Checklist
                              </a>
                            </p>
                          </div>
                        </td>
                        <td>
                          <span className='badge bg-light-success'>Active</span>
                        </td>
                        <td className='table-action'>
                          <div className='dropdown'>
                            <a
                              href='javascript:void(0);'
                              className='dropdown-toggle'
                              data-bs-toggle='dropdown'
                            >
                              <i className='feather-more-vertical'></i>
                            </a>
                            <div className='dropdown-menu dropdown-menu-end'>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-eye'></i> View
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-edit'></i> Edit
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-trash-2'></i> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className='table-checkbox'>
                            <label className='check-input'>
                              <input type='checkbox' />
                              <span className='box'></span>
                            </label>
                          </div>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck3}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Semi- Truck <span>AB06 CD 1234</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <h2 className='table-avatar'>
                            <a
                              href='javascript:void(0);'
                              className='avatar avatar-sm me-2'
                            >
                              <img
                                className='avatar-img rounded-circle'
                                src={truck4}
                                alt='Profiles'
                              />
                            </a>
                            <a href='javascript:void(0);'>
                              Nicholas <span>ABC Company</span>
                            </a>
                          </h2>
                        </td>
                        <td>
                          <div className='data-check-list'>
                            <ul className='nav'>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-danger'></span>
                              </li>
                              <li>
                                <span className='check-list-danger'></span>
                              </li>
                              <li>
                                <span className='check-list-danger'></span>
                              </li>
                            </ul>
                            <p>
                              15/<span>30</span>
                              <a
                                href='javascript:void(0);'
                                className='view-checklist'
                              >
                                View Checklist
                              </a>
                            </p>
                          </div>
                        </td>
                        <td>
                          <span className='badge bg-light-danger'>
                            Blacklist
                          </span>
                        </td>
                        <td className='table-action'>
                          <div className='dropdown'>
                            <a
                              href='javascript:void(0);'
                              className='dropdown-toggle'
                              data-bs-toggle='dropdown'
                            >
                              <i className='feather-more-vertical'></i>
                            </a>
                            <div className='dropdown-menu dropdown-menu-end'>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-eye'></i> View
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-edit'></i> Edit
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-trash-2'></i> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='tab-footer'>
                  <div className='row align-items-center'>
                    <div className='col-md-6'>
                      <div id='tableinfo'></div>
                    </div>
                    <div className='col-md-6'>
                      <div id='tablepage'></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-12'>
            <div className='dashboard-header'>
              <div className='row align-items-center'>
                <div className='col-md-6'>
                  <h4>Report</h4>
                </div>
                <div className='col-md-6'>
                  <div className='dashboard-view-link'>
                    <a href='javascript:void(0);'>View All</a>
                  </div>
                </div>
              </div>
            </div>
            <div className='card'>
              <div className='card-body'>
                <div className='report-details'>
                  <div className='report-details-inner'>
                    <h6>15+</h6>
                    <p>
                      <span>Trucks</span> Thursday 06, 2024
                    </p>
                  </div>
                  <div className='report-right-icon'>
                    <span>
                      <i className='feather-trending-up'></i>
                    </span>
                  </div>
                </div>
                <div className='dashboard-chart'>
                  <img src={chart} className='img-fluid' alt='Chart' />
                </div>
              </div>
            </div>
            <div className='dashboard-video-info'>
              <div className='dashboard-header'>
                <div className='row align-items-center'>
                  <div className='col-md-6'>
                    <h4>Video (5)</h4>
                  </div>
                  <div className='col-md-6'>
                    <div className='dashboard-view-link'>
                      <a href='javascript:void(0);'>View All</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-xl-4 col-lg-12'>
                  <div className='dashboard-video-img'>
                    <img src={truck5} className='img-fluid' alt='Truck' />
                    <a href='javascript:void(0);'>
                      <i className='feather-play-circle'></i>
                    </a>
                  </div>
                </div>
                <div className='col-xl-8 col-lg-12'>
                  <div className='dashboard-video-text'>
                    <h6>How to check checklist.mp4</h6>
                    <p>15MB</p>
                    <ul className='nav'>
                      <li>
                        <a
                          href='javascript:void(0);'
                          className='btn btn-primary'
                        >
                          <i className='feather-play-circle'></i> Play
                        </a>
                      </li>
                      <li>
                        <a
                          href='javascript:void(0);'
                          className='btn btn-secondary'
                        >
                          <i className='feather-trash-2'></i> Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Dashboard --> */}
    </>
  )
}

export default AdminDashboard
